import Client from "@/repositories/Clients/AxiosClient";
import Config from "@/repositories/Clients/AxiosDefaultConfig";

const resource = `${Config.basePath}/merchant`;

export default {
  show() {
    return Client.get(`${resource}`);
  },
  update(payload) {
    return Client.put(`${resource}`, payload);
  },
};
